import axios from 'axios';
import CONFIG from '../config/config';
import { instanceWithV2 as instance } from './SimpleAPIClient';

export type FileUrl = {
  url: string;
};

const FilesAPI = {
  getUrl: (fileName: string, type: string = 'orders', prefixId?: string) => {
    const fName = encodeURIComponent(fileName);
    const queryParams = new URLSearchParams();
    if (type) queryParams.append("type", type);
    if (prefixId) queryParams.append("prefixId", prefixId);
    return instance(CONFIG.API_ENDPOINT).get<FileUrl>(`/v1/files/${type}/signUrl/read/${fName}${!!queryParams.toString() ? `?${queryParams.toString()}` : ''}`)
  },
  getUrlForSharedResource: (xOrderId: number, fileName: string) => {
    const fName = encodeURIComponent(fileName);
    return instance(CONFIG.API_ENDPOINT).get<FileUrl>(`/v1/files/shared/orders/${xOrderId}/signUrl/read/${fName}`)
  },
  getUploadUrl: (fileName: string, type: string = "orders", prefixId?: string) => {
    let url = `/v1/files/${type}/signUrl/upload`;
    if (prefixId) {
      url += `?prefixId=${prefixId}`;
    }
    return instance(CONFIG.API_ENDPOINT).get<FileUrl>(url, {
      headers: {
        'Filename': fileName,
      },
    })
  },
  upload: (resourceApi: string, filename: string, file: FormData) => {
    return instance(CONFIG.API_ENDPOINT).post<FileUrl>(resourceApi, file, {
      headers: {
        'Filename': filename
      },
    })
  },
  uploadHeavyFile: (uploadUrl: string, file: File, fileName: string) => {
    return axios.put(uploadUrl, file
      , {
      headers: {
        'Filename': fileName,
        'Content-Type': file.type,
      },
      }
    )
  },
  
  getPublicUrl: (fileName: string, trackingId: string) => {
    const fName = encodeURIComponent(fileName);
    return instance(CONFIG.API_ENDPOINT).get<FileUrl>(`/v1/files/public/commission-contracts/signUrl/read/${fName}?prefixId=${trackingId}`)
  },
  
  getPublicUploadUrl: (fileName: string, trackingId: string) => {
    return instance(CONFIG.API_ENDPOINT).get<FileUrl>(`/v1/files/public/commission-contracts/signUrl/upload`, {
      headers: {
        'Filename': fileName,
      },
      params: {
        prefixId: trackingId
      }
    })
  },
  
  uploadPublic: (filename: string, file: FormData, trackingId: string) => {
    return instance(CONFIG.API_ENDPOINT).post<FileUrl>(`/v1/files/public/commission-contracts/uploadV2?prefixId=${trackingId}`, file, {
      headers: {
        'Filename': filename
      },
    })
  },
  
  uploadPublicHeavyFile: (uploadUrl: string, file: File, fileName: string) => {
    return axios.put(uploadUrl, file, {
      headers: {
        'Filename': fileName,
        'Content-Type': file.type,
      },
    })
  },
};

export default FilesAPI;
